<template>
    <div class="column field">
        <div style="display:flex">
            <label v-if="label" class="label">{{ label }}</label>
            <slot name="top"/>
        </div>

        <div class="mb-2" style="display:flex">
            <p>Draw your signature on the signature pad.</p>
            <SaveButton class="ml-2" label="Clear" icon="fa-eraser" @click="(signaturePad as any).clearSignature()"/>
        </div>
        
        
        <SignaturePad id="pad" ref="signaturePad" />
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import SignaturePad from 'vue3-signature-pad';

defineProps<{
  label?: string
}>();

const signaturePad = ref(null);

const isSignatureEmpty = () => {
    return (signaturePad.value as any).isEmpty();
};

const getSignatureData = () => {
    return (signaturePad.value as any).saveSignature().data;
}

defineExpose({
    isSignatureEmpty,
    getSignatureData
});
</script>

<style scoped>
#pad {
    border: 2px solid #42BDB4;
    padding: 0.5rem 0.5rem;
    border-radius: 2px;
    width: 100% !important;
    max-width: 500px !important;
    height: 185px !important;
    box-sizing: border-box;
    font-size: 1rem;
}
input:focus{
    border: 1px solid #0C4E58;
    outline: 1px solid #0C4E58;
}
</style>
